import * as tslib_1 from "tslib";
import { jsonArrayMember, jsonMember, jsonObject } from "typedjson";
import { PitRequestCriteriaFilter } from "./pit-request-criteria-filter";
import { PitRequestCriteriaSort } from "./pit-request-criteria-sort";
import { PitRequestCriteriaPage } from "./pit-request-criteria-page";
/** Набор критериев для выборки */
let PitRequestCriteria = class PitRequestCriteria {
    constructor(fields) {
        /** Массив наименований полей, ожидаемых в ответе */
        this._fields = [];
        /** Массив условий фильтрации выборки */
        this._filters = [];
        this._sorts = [];
        this._page = new PitRequestCriteriaPage();
        if (fields)
            Object.assign(this, fields);
    }
    get fields() {
        return this._fields;
    }
    set fields(value) {
        this._fields = value;
    }
    get filters() {
        return this._filters;
    }
    set filters(value) {
        this._filters = value;
    }
    get sorts() {
        return this._sorts;
    }
    set sorts(value) {
        this._sorts = value;
    }
    get page() {
        return this._page;
    }
    set page(value) {
        this._page = value;
    }
};
tslib_1.__decorate([
    jsonArrayMember(String, { name: "fields", emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Array)
], PitRequestCriteria.prototype, "_fields", void 0);
tslib_1.__decorate([
    jsonArrayMember(PitRequestCriteriaFilter, { name: "filters", emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Array)
], PitRequestCriteria.prototype, "_filters", void 0);
tslib_1.__decorate([
    jsonArrayMember(PitRequestCriteriaSort, { name: "sorts", emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Array)
], PitRequestCriteria.prototype, "_sorts", void 0);
tslib_1.__decorate([
    jsonMember({ name: "page", constructor: PitRequestCriteriaPage, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", PitRequestCriteriaPage)
], PitRequestCriteria.prototype, "_page", void 0);
PitRequestCriteria = tslib_1.__decorate([
    jsonObject,
    tslib_1.__metadata("design:paramtypes", [Object])
], PitRequestCriteria);
export { PitRequestCriteria };
